<template>
  <div class="process-operation-wrapper">
    <div class="process-operation-count">
      <span>Processing {{ processList.length }} Operation(s)</span>
      <span class="p-1" style="cursor: pointer" @click="toggleList">
        <UpOutlined v-if="hide" />
        <DownOutlined v-else />
      </span>
    </div>

    <div class="process-operation-list" :class="{ hidden: hide }">
      <div
        v-for="process in processList"
        :key="process.id"
        class="process-item"
      >
        <div class="d-flex justify-content-between align-center w-100">
          <div class="d-flex gap-2 align-center" style="width: 85%">
            <i
              style="font-size: 1.8em"
              class="text-primary align-self-center bi bi-gear"
            ></i>

            <div class="d-flex flex-column gap-1">
              <a-tooltip :title="process.name">
                <span class="process-name">
                  {{ process.name }}
                </span>
              </a-tooltip>
              <span class="process-type"> {{ processType }} </span>
            </div>
          </div>

          <a-tag
            v-if="process.status === 'Queue'"
            color="warning"
            class="d-flex align-items-center"
          >
            In Queue
          </a-tag>
          <template v-else>
            <a-space class="d-flex align-items-center">
              <a-progress
                type="circle"
                class="d-flex align-items-center"
                :percent="Math.round(process.progress)"
                :width="40"
              />
              <a-popconfirm
                v-if="showClose"
                title="Are you sure you want to delete?"
                ok-text="Yes"
                cancel-text="No"
                @confirm="handleClose(process.id)"
              >
                <CloseOutlined style="color: red; cursor: pointer" />
              </a-popconfirm>
            </a-space>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CloseOutlined, DownOutlined, UpOutlined } from '@ant-design/icons-vue';
export default {
  components: {
    DownOutlined,
    UpOutlined,
    CloseOutlined,
  },

  props: {
    processList: { type: Array, required: true, default: () => [] },
    processType: { type: String, required: true, default: '' },
    showClose: { type: Boolean, required: false, default: false },
  },

  emits: ['closeProgress'],

  data() {
    return {
      hide: false,
    };
  },

  methods: {
    toggleList() {
      this.hide = !this.hide;
    },

    handleClose(id) {
      this.$emit('closeProgress', id);
    },
  },
};
</script>

<style scoped>
.process-operation-wrapper {
  border-radius: 16px 16px 0 0;
  max-height: 250px;
  background-color: #fff;
  width: 25vw;
  position: absolute;
  bottom: 1%;
  right: 4%;
  z-index: 99;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

.process-operation-count {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  position: relative;
  font-weight: 400;
}

.process-operation-count::after,
.process-item:not(:last-child)::after {
  content: '';
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 1px;
  background: #c1c1c13d;
}

.process-operation-list {
  padding: 10px 20px;
  max-height: 150px;
  min-height: 60px;
  overflow-y: auto;
}

.process-operation-list.hidden {
  display: none;
}

.process-item {
  padding: 10px 0;
  font-size: 14.8px;
  width: 100%;
  text-transform: capitalize;
  position: relative;
  display: inline-flex;
  gap: 8px;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.process-item:first-child {
  padding-top: 0;
}

.process-item:last-child {
  padding-bottom: 0;
}

.process-name {
  max-width: calc(25vw - 130px);
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
}
.process-type {
  color: gray;
  max-width: calc(25vw - 130px);
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
